<template>
    <activation-preview-provider
        v-slot="{
            brief,
            step,
        }"
        :module-name="moduleName"
    >
        <activation-brief-agreements-view
            v-if="brief"
            :brief="brief"
            :step="step"
            :is-preview="true"
        />
        <g-loader v-else type="fixed" />
    </activation-preview-provider>
</template>

<script>
    import ActivationPreviewProvider from '../../providers/preview-providers/ActivationPreviewProvider';
    import ActivationBriefAgreementsView from '../../data-views/activation-briefs/ActivationBriefAgreementsView';
    import PageMask from '../../library/PageMask';
    import {NAME_CONTENT_AGREEMENT} from '../../../constants/activation-brief-steps';

    export default {
        name:       'ActivationAgreementsPreviewRouterView',
        components: {
            ActivationBriefAgreementsView,
            ActivationPreviewProvider,
            PageMask,
        },
        data(){
            return {
                moduleName: NAME_CONTENT_AGREEMENT,
            };
        },
    };
</script>
